// const baseUrl = "http://localhost:8000/api";
const baseUrl = "https://drug-loft-xpress.herokuapp.com/api";
export default baseUrl;
